export function generatePassword(length=8) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let pass = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        pass += charset[Math.floor(Math.random() * n)];
    }
    return pass;
}